<ng-container *ngIf="PaymentResponse == null else receipt">
  <div class="wrapper">
    <div class="container px-0">
      <h5 class="main-title">{{patientpersonalinfo?.PracticeName}}</h5>
      <!--<div class="main-info">
        {{'paymentPage.paymentInformation' |translate}}
      </div>-->
      <div *ngIf="!isExistingcard" class="pb-2 fw-bold">
        <h5 class="title text-center mb-2 mt-2 fw-bold">{{'paymentPage.paymentInformation' |translate}}</h5>
      </div>
      <div *ngIf="isExistingcard" class=" pb-2 fw-bold">
        <h5 class="title text-center mb-2 mt-2 fw-bold"> {{'checkinpayment.saveCardpayment_title'|translate}}</h5>
      </div>
      <!--<div class="">
      <form [formGroup]="paymentForm">
        <div class="form-row">
          <div class="col-md-4">
            <div class="form-group">
              <div class="border-bottom mb-2">
                <label style="font-size:20px;" class="fw-bold">{{'paymentPage.firstName' |translate}}<span class="text-danger">*</span></label>
                <div class="input-icon">
                  <input formControlName="firstname" maxlength="35" (input)="validateName($event, 'firstname')" [ngStyle]="{'border' : getpaymentForm.firstname.invalid
                && getpaymentForm.firstname.touched && getpaymentForm.firstname.errors!.required ? '1px solid red' : ''}" type="text" class="form-control border-0" placeholder="{{'paymentPage.firstName' |translate}}">
                </div>
              </div>
              <span *ngIf="getpaymentForm.firstname.invalid && getpaymentForm.firstname.touched">
                <span *ngIf="getpaymentForm.firstname.errors!.required" class="text-danger">   {{'paymentPage.firstnamerequired' |translate}}</span>
              </span>

            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group ">
              <div class="border-bottom mb-2">
                <label style="font-size:20px;" class="fw-bold">{{'paymentPage.lastName' |translate}}<span class="text-danger">*</span></label>
                <div class="input-icon form-floating">
                  <input formControlName="lastname" maxlength="35" (input)="validateName($event, 'lastname')" [ngStyle]="{'border' : getpaymentForm.lastname.invalid
                && getpaymentForm.lastname.touched && getpaymentForm.lastname.errors!.required ? '1px solid red' : ''}"
                         type="text" class="form-control border-0" placeholder="{{'paymentPage.lastName' |translate}}">
                </div>
              </div>
              <span *ngIf="getpaymentForm.lastname.invalid && getpaymentForm.lastname.touched">
                <span *ngIf="getpaymentForm.lastname.errors!.required" class="text-danger">{{'paymentPage.lastnamerequired' |translate}}</span>
              </span>
            </div>
          </div>-->
      <!-- <div class="col-md-4">
        <div class="form-group form-floating">
          <input formControlName="amount" (change)="validateCurrenyChange($event)"
          (keypress)="validateCurreny($event)" [ngStyle]="{'border' : getpaymentForm.amount.invalid
          && getpaymentForm.amount.touched && getpaymentForm.amount.errors!.required ? '1px solid red' : ''}" type="text" class="form-control" placeholder="Amount">
          <label [ngClass]="getpaymentForm.amount.invalid && getpaymentForm.amount.touched
          && getpaymentForm.amount.errors!.required ? 'text-danger' : ''">Amount  <span class="text-danger">*</span> </label>
          <small class="due-amount text-danger">Due Amount: ${{paymentDetials.data.amT_DUE | number : '.2-2'}}</small>
          <span *ngIf="getpaymentForm.amount.invalid && getpaymentForm.amount.touched">
            <span *ngIf="getpaymentForm.amount.errors!.required" class="text-danger">Amount is required.</span>
            <span *ngIf="getpaymentForm.amount.errors!.max" class="text-danger">Payment is exceeding maximum limit $4999.00.</span>
            <span *ngIf="getpaymentForm.amount.errors!.invalidinput" class="text-danger">Invalid amount.</span>
            <span *ngIf="getpaymentForm.amount.errors!.greaterThanTotalDues" class="text-danger">Payment should not be greater than Total Dues.</span>
          </span>
        </div>
      </div> -->
      <!--<div class="col-md-4">
        <div class="form-group">
          <div class="border-bottom mb-2">
            <label style="font-size:20px;" class="fw-bold">{{'paymentPage.amount' |translate}}<span class="text-danger">*</span></label>
            <i _ngcontent-pqg-c5="" class="fa fa-dollar-sign form-control-feedback"></i>
            <input formControlName="amount" maxlength="7"
                   (keypress)="validateCurreny($event)"
                   [ngStyle]="{'border' : (getpaymentForm.amount.invalid  || this.paymentForm.controls['amount'].value>4999)
            && (getpaymentForm.amount.touched || this.paymentForm.controls['amount'].value>4999 )  && ( getpaymentForm.amount.errors!.required ||  this.paymentForm.controls['amount'].value>4999) ? '1px solid red' : ''}" type="text" class="form-control border-0" style="padding-left: 32px !important;" placeholder="{{'paymentPage.amount' |translate}}">
          </div>
          <small class="due-amount text-danger">{{'paymentPage.dueAmount' |translate}}: $ {{paymentDetials.data.amT_DUE | number : '.2-2'}}</small>
          <span *ngIf="getpaymentForm.amount.invalid && getpaymentForm.amount.touched">
            <span *ngIf="getpaymentForm.amount.errors!.required" class="text-danger">{{'paymentPage.paymenShouldNotGreaterThanTotal' |translate}}</span>
          </span>
          <span *ngIf=" +this.paymentForm.controls['amount'].value > amountDueTemp && !this.isNewPatient && +this.paymentForm.controls['amount'].value <=4999" class="text-danger">{{'paymentPage.paymenShouldNotGreaterThanTotal' | translate}}</span>
          <span *ngIf="+this.paymentForm.controls['amount'].value>4999" class="text-danger">{{'paymentPage.paymenIsExceedingLimit' |translate}} $4999.00.</span>
        </div>
      </div>
      <div class="col-md-8 col-lg-4">
        <div class="form-group">
          <label style="font-size:20px;" class="fw-bold">{{'paymentPage.creditCardNumber' |translate}}<span class="text-danger">*</span></label>
          <input formControlName="ccn" [ngStyle]="{'border' : getpaymentForm.ccn.invalid
          && getpaymentForm.ccn.touched && getpaymentForm.ccn.errors!.required ? '1px solid red' : ''}" type="text" class="form-control border-left-0 border-top-0 border-right-0"
                 placeholder="{{'paymentPage.creditCardNumber' |translate}}" autocomplete="off" (keypress)="validateNumber($event, 19)" (input)="checkCCT($event)" autocomplete="off">-->
      <!--<label [ngClass]="(getpaymentForm.ccn.invalid && getpaymentForm.ccn.touched)
      && (getpaymentForm.ccn.errors!.required || getpaymentForm.ccn.errors!.minlength || creditCType == '') ? 'text-danger' : ''">{{'paymentPage.creditCardNumber' |translate}} <span class="text-danger">*</span> </label>-->
      <!--<span class="crimg">
            <img *ngIf="creditCType != ''" src="{{creditCType}}" alt="">
          </span>
          <span *ngIf="getpaymentForm.ccn.invalid && getpaymentForm.ccn.touched">
            <span *ngIf="getpaymentForm.ccn.errors!.required" class="text-danger">{{'paymentPage.creditCardNumberRequired' |translate}}</span>
            <span *ngIf="getpaymentForm.ccn.errors!.invalidNumber" class="text-danger">{{'paymentPage.creditCardNumberInvalid' |translate}}</span>
          </span>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6  col-md-4">
        <div class="form-group mb-0 mb-sm-auto">
          <label style="font-size:20px;" class="fw-bold">{{'paymentPage.cvv' |translate}}<span class="text-danger">*</span></label>
          <input type="text" formControlName="cvv" (input)="validateNumber($event, 4)" maxlength="4" [ngStyle]="{'border' : getpaymentForm.cvv.invalid
          && getpaymentForm.cvv.touched && getpaymentForm.cvv.errors!.required ? '1px solid red' : ''}" class="form-control border-left-0 border-top-0 border-right-0" placeholder="{{'paymentPage.cvv' |translate}}">-->
      <!--<label [ngClass]="getpaymentForm.cvv.invalid && getpaymentForm.cvv.touched
      && getpaymentForm.cvv.errors!.required ? 'text-danger' : ''">{{'paymentPage.cvv' |translate}}<span class="text-danger">*</span> </label>-->
      <!--<span *ngIf="getpaymentForm.cvv.invalid && getpaymentForm.cvv.touched">
            <span *ngIf="getpaymentForm.cvv.errors!.required" class="text-danger">{{'paymentPage.cvvrequired' |translate}}</span>
            <span *ngIf="getpaymentForm.cvv.errors!.minlength" class="text-danger">{{'paymentPage.cvvInvalid' |translate}}</span>
          </span>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6  col-md-4">
        <div class="form-group mb-0 mb-sm-auto">
          <label style="font-size:20px;" class="fw-bold">{{'paymentPage.expiryDate' |translate}}<span class="text-danger">*</span></label>
          <div class="position-relative form-floating ">
            <input id="expirydate" name="expirydate" min="{{currentYear}}-{{currentMonth}}" value="{{currentYear}}-{{currentMonth}}" type="month" formControlName="expirydate" [ngStyle]="{'border' : getpaymentForm.expirydate?.invalid
            && getpaymentForm.expirydate?.touched && getpaymentForm.expirydate?.errors?.required ? '1px solid red' : ''}"
                   (focusout)="focusOutDate($event)" class="form-control border-left-0 border-top-0 border-right-0" placeholder="{{'paymentPage.expiryDate' |translate}}">-->
      <!--<label for="expirydate" [ngClass]="getpaymentForm.expirydate.invalid && getpaymentForm.expirydate.touched
      && getpaymentForm.expirydate.errors!.required ? 'text-danger' : ''">{{'paymentPage.expiryDate' |translate}}<span class="text-danger">*</span></label>-->
      <!--<span *ngIf="getpaymentForm.expirydate.invalid && getpaymentForm.expirydate.touched">
              <span *ngIf="getpaymentForm.expirydate.errors!.required" class="text-danger">{{'paymentPage.expiryDateRequired' |translate}}</span>
            </span>
          </div>
        </div>
      </div>-->
      <!--<div class="col-md-12">
        <hr class="mt-0 mb-4">
      </div>-->
      <!--<div class="col-md-4">
      <div class="form-group">
        <label style="font-size:20px;" class="fw-bold">{{'paymentPage.cellNumber' |translate}}<span class="text-danger">*</span></label>
        <input formControlName="cell" maxlength="14" (input)="validatePhoneNo($event)" [ngStyle]="{'border' : getpaymentForm.cell?.invalid
        && getpaymentForm.cell.touched && getpaymentForm.cell.errors!.required ? '1px solid red' : ''}" type="text" class="form-control border-left-0 border-top-0 border-right-0" placeholder="{{'paymentPage.cellNumber' |translate}}">-->
      <!--<label [ngClass]="getpaymentForm.cell.invalid && getpaymentForm.cell.touched && getpaymentForm.cell.errors!.required ? 'text-danger' : ''">
        {{'paymentPage.cellNumber' |translate}}
        <span class="text-danger">*</span>
      </label>-->
      <!--<span *ngIf="getpaymentForm.cell.invalid && getpaymentForm.cell.touched">
            <span *ngIf="getpaymentForm.cell.errors!.required" class="text-danger">{{'paymentPage.cellNumberRequired' |translate}} </span>
          </span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label style="font-size:20px;" class="fw-bold">{{'paymentPage.addressLine1' |translate}}<span class="text-danger">*</span></label>
          <input formControlName="addressl1" maxlength="50" [ngStyle]="{'border' : getpaymentForm.addressl1.invalid
          && getpaymentForm.addressl1.touched && getpaymentForm.addressl1.errors!.required ? '1px solid red' : ''}" type="text" class="form-control border-left-0 border-top-0 border-right-0" placeholder="{{'paymentPage.addressLine1' |translate}}">-->
      <!--<label [ngClass]="getpaymentForm.addressl1.invalid && getpaymentForm.addressl1.touched
      && getpaymentForm.addressl1.errors!.required ? 'text-danger' : ''">{{'paymentPage.addressLine1' |translate}} <span class="text-danger">*</span> </label>-->
      <!--<span *ngIf="getpaymentForm.addressl1.invalid && getpaymentForm.addressl1.touched">
            <span *ngIf="getpaymentForm.addressl1.errors!.required" class="text-danger">{{'paymentPage.addressLine1Required' |translate}}</span>
          </span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label style="font-size:20px;" class="fw-bold">{{'paymentPage.addressLine2' |translate}}</label>
          <input formControlName="addressl2" type="text" class="form-control border-left-0 border-top-0 border-right-0" maxlength="27" placeholder="{{'paymentPage.addressLine2Placeholder' |translate}}">-->
      <!--<label>{{'paymentPage.addressLine2' |translate}}</label>-->
      <!--</div>
      </div>-->
      <!--<div class="col-md-12">
        <hr class="mt-0 mb-4">
      </div>-->
      <!--<div class="col-md-4">
      <div class="form-group">
        <label style="font-size:20px;" class="fw-bold">{{'paymentPage.zipCode' |translate}}<span class="text-danger">*</span></label>
        <input formControlName="zip" maxlength="10" minlength="5" [ngStyle]="{'border' : getpaymentForm.zip?.invalid
        && getpaymentForm.zip?.touched && getpaymentForm.zip?.errors!.required ? '1px solid red' : ''}"
               type="text" class="form-control border-left-0 border-top-0 border-right-0" placeholder="{{'paymentPage.zipCode' |translate}}"
               (input)="onlyNumberAllow($event)">-->
      <!--<label [ngClass]="getpaymentForm.zip.invalid && getpaymentForm.zip.touched
      && getpaymentForm.zip.errors!.required ? 'text-danger' : ''">{{'paymentPage.zipCode' |translate}}<span class="text-danger">*</span> </label>-->
      <!--<span *ngIf="getpaymentForm.zip.invalid && getpaymentForm.zip.touched">
            <span *ngIf="getpaymentForm.zip.errors!.required" class="text-danger">{{'paymentPage.zipCodeRequired' |translate}}</span>
          </span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group form-select">
          <label style="font-size:20px;" class="fw-bold">{{'paymentPage.city' |translate}}<span class="text-danger">*</span></label>
          <select [ngStyle]="{'border' : getpaymentForm.city.invalid
          && getpaymentForm.city.touched && getpaymentForm.city.errors!.required ? '1px solid red' : ''}" formControlName="city" [attr.readonly]="cityStateList.length == 0 ? true : null"
                  class="form-control border-left-0 border-top-0 border-right-0" (change)="showState($event)">
            <option selected disabled value>{{'paymentPage.city' |translate}}</option>
            <option *ngFor="let city of cityStateList; let i = index;" [selected]="i == 0" value="{{city.cityName}}">{{city.cityName}}</option>
          </select>-->
      <!--<label [ngClass]="getpaymentForm.city.invalid && getpaymentForm.city.touched
      && getpaymentForm.city.errors!.required ? 'text-danger' : ''">{{'paymentPage.city' |translate}} <span class="text-danger">*</span> </label>-->
      <!--<span *ngIf="getpaymentForm.city.invalid && getpaymentForm.city.touched">
            <span *ngIf="getpaymentForm.city.errors!.required" class="text-danger">{{'paymentPage.cityRequired' |translate}}</span>
          </span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group form-select">
          <label style="font-size:20px;" class="fw-bold">{{'paymentPage.state' |translate}}<span class="text-danger">*</span></label>
          <input readonly formControlName="state" [ngStyle]="{'border' : getpaymentForm.state.invalid
        && getpaymentForm.state.touched && getpaymentForm.state.errors!.required ? '1px solid red' : ''}" type="text" class="form-control border-left-0 border-top-0 border-right-0" placeholder="{{'paymentPage.state' |translate}}">-->
      <!--<label [ngClass]="getpaymentForm.state.invalid && getpaymentForm.state.touched
      && getpaymentForm.state.errors!.required ? 'text-danger' : ''">{{'paymentPage.state' |translate}} <span class="text-danger">*</span> </label>-->
      <!--<span *ngIf="getpaymentForm.state.invalid && getpaymentForm.state.touched">
                  <span *ngIf="getpaymentForm.state.errors!.required" class="text-danger">{{'paymentPage.stateRequired' |translate}}.</span>
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>-->
      <!--new design-->
      <div *ngIf="isExistingcard">
        <div class="form-row">
          <div class="col-md-4">
            <div class="form-group">
              <div class="border-bottom mb-2">
                <label class="fw-bold mb-2">
                  {{ 'checkinpayment.you_are_paying' | translate }} <span style="color: #5bc5d0;">${{amount}}</span>
                </label>
              </div>
            </div>
          </div>
          <div class=" col-md-4 mb-2">
            <label *ngIf="cardInfo.length>1" class="fw-bold mb-2"> {{'checkinpayment.choose_card'|translate}}</label>
            <label *ngIf="cardInfo.length==1" class="fw-bold mb-2"> {{'checkinpayment.select_card'|translate}}</label>
          </div>
        </div>
        <div class="container flex-grow-1 overflow-auto" style=" padding-right: 0px !important; padding-left: 0px !important;">
          <div class="specialist-list">
            <div class="">
              <div class="ltr-component" *ngFor="let card of cardInfo">
                <div class="card mb-4 pb-3">
                  <div class="card-body p-0 mt-2">
                    <div class="align-items-center d-flex justify-content-between">
                      <div>
                        <img width="32" class="mr-3" [src]="getCardImage(card.card_type)" />
                        <div class="card-details">
                          <label class="mb-0">{{card.card_type}} <strong>****{{card.token_number| slice:-4}}</strong></label>
                          <small class="text-danger d-block" *ngIf="isCardExpired(card.expiration_month, card.expiration_year)">{{'checkinpayment.card_expired'|translate}}</small>
                          <small class=" d-block" style="color: #53b0ba;" *ngIf="isCardExpiringSoon(card.expiration_month, card.expiration_year)">{{'checkinpayment.expiring_soon'|translate}}</small>
                        </div>
                      </div>

                      <div class="ctabtns">
                        <small *ngIf="isCardExpired(card.expiration_month, card.expiration_year)" class="text-dark d-block" (click)="deleteCardInfo(card)"> {{'link.delete'|translate}}</small>
                        <div *ngIf="!isCardExpired(card.expiration_month, card.expiration_year)" class="custom-control custom-radio">
                          <input class="custom-control-input" type="radio" name="creditcard" [id]="card.credit_card_id" (change)="selectCard(card)">
                          <label [for]="card.credit_card_id" class="custom-control-label mb-2"></label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-1 text-center">
          <button class="btn btn-primary btncare mt-5" type="button" (click)="addNewCard()">{{'button.add_new'|translate}}</button>
        </div>
        <div class="col-md-12 mt-1 text-center">
          <button class="btn btn-primary btncare mt-4" type="button" (click)="onSubmitPayment()">{{'button.make_payment'|translate}}</button>
        </div>
      </div>



      <div *ngIf="!isExistingcard">
        <form [formGroup]="paymentForm">
          <div class="form-row">
            <div class="col-md-4">
              <div class="form-group">
                <div class="border-bottom mb-2">
                  <label class="fw-bold mb-2">
                    {{ 'checkinpayment.you_are_paying' | translate }} <span style="color: #5bc5d0;">${{amount}}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group ">
                <div class=" border-bottom mb-2">
                  <label class="fw-bold">{{'checkinpayment.nameon_card' |translate}}<span class="text-danger">*</span> </label>
                  <input formControlName="nameOnCard" maxlength="35" (input)="validatenameonCard($event, 'nameOnCard')"
                         type="text" class="form-control border-0 ltr-component" placeholder="{{'checkinpayment.nameon_card_placeholder' |translate}}">

                </div>
                <span *ngIf="getpaymentForm.nameOnCard.invalid && getpaymentForm.nameOnCard.touched" class="err">
                  <span *ngIf="getpaymentForm.nameOnCard.errors!.required" class="text-danger">{{'checkinpayment.nameon_card_error' |translate}}</span>
                </span>
              </div>
            </div>
            <div class="col-md-8 col-lg-4 ">
              <div class="form-group">
                <div class=" border-bottom mb-2">
                  <label class="fw-bold">{{'checkinpayment.CardNumber' |translate}}<span class="text-danger">*</span> </label>
                  <input type="text" inputmode="numeric" formControlName="ccn" [ngStyle]="{'border' : getpaymentForm.ccn.invalid
&& getpaymentForm.ccn.touched && getpaymentForm.ccn.errors!.required ? '1px solid red' : ''}" type="text" class="form-control border-0 ltr-component"
                         placeholder="{{'checkinpayment.CardNumber_placeholder' |translate}}" autocomplete="off" (keypress)="validateNumber($event, 19)" (input)="checkCCT($event)" autocomplete="off">

                  <span class="crimg">
                    <img *ngIf="creditCType != ''" src="{{creditCType}}" alt="">
                  </span>

                </div>
                <span *ngIf="getpaymentForm.ccn.invalid && getpaymentForm.ccn.touched" class="err">
                  <span *ngIf="getpaymentForm.ccn.errors!.required" class="text-danger">{{'checkinpayment.CardNumberRequired' |translate}}</span>
                  <span *ngIf="getpaymentForm.ccn.errors!.invalidNumber" class="text-danger">{{'checkinpayment.CardNumberInvalid' |translate}}</span>
                </span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group ">
                <div class="position-relative">
                  <label class="fw-bold">{{'paymentPage.expiryDate' |translate}}<span class="text-danger">*</span></label>
                  <div class="d-flex ">
                    <div class="col-md-6 col-6 " style="padding-left:0px !important">
                      <div class=" form-select border-bottom mb-2">
                        <select formControlName="dobMonth" class="form-control text-capitalize border-0" placeholder="Month">
                          <option value="" disabled selected>{{'verifypatient.month'|translate}}</option>
                          <option *ngFor="let month of months; let i = index" [value]="i+1">{{ month }}</option>
                        </select>
                      </div>
                      <span id="f-zip-err" class="err"
                            *ngIf="paymentForm.controls['dobMonth'].touched && paymentForm.controls['dobMonth'].invalid">
                        <span class="err"
                              *ngIf="paymentForm.controls['dobMonth'].errors && paymentForm.controls['dobMonth'].errors.required">
                          {{'verifypatient.month_error_msg'|translate}}.
                        </span>
                      </span>
                    </div>

                    <div class="col-md-6 col-6 " style="padding-left:0px !important">
                      <div class=" form-select border-bottom mb-2">
                        <select formControlName="dobyear" class="form-control text-capitalize border-0">
                          <option value="" disabled selected>{{'verifypatient.year'|translate}}</option>
                          <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                        </select>
                      </div>
                      <span id="f-zip-err" class="err"
                            *ngIf="paymentForm.controls['dobyear'].touched && paymentForm.controls['dobyear'].invalid">
                        <span class="err"
                              *ngIf="paymentForm.controls['dobyear'].errors && paymentForm.controls['dobyear'].errors.required">
                          {{'verifypatient.year_error_msg'|translate}}.
                        </span>
                      </span>
                    </div>

                  </div>
                </div>

              </div>

            </div>

            <div class="col-xs-6 col-sm-6 col-md-4" style="margin-top: -8px">

              <div class="form-group">

                <div class="border-bottom mb-2 mb-sm-auto">
                  <label class="fw-bold">
                    {{ 'paymentPage.cvv' | translate }}<span class="text-danger">*</span>
                  </label>

                  <!-- CVV Input Field -->
                  <input type="text" inputmode="numeric" formControlName="cvv" (input)="validateNumber($event, 4)" maxlength="4"
                         [ngStyle]="{'border' : getpaymentForm.cvv.invalid && getpaymentForm.cvv.touched && getpaymentForm.cvv.errors!.required ? '1px solid red' : ''}"
                         class="form-control border-0 ltr-component" placeholder="{{ 'paymentPage.cvv_placeholder' | translate }}" style="flex: 1;" />

                </div>

                <!-- Error Messages -->
                <span *ngIf="getpaymentForm.cvv.invalid && getpaymentForm.cvv.touched" class="err">
                  <span *ngIf="getpaymentForm.cvv.errors!.required" class="text-danger">{{ 'paymentPage.cvvrequired' | translate }}</span>
                  <span *ngIf="getpaymentForm.cvv.errors!.minlength" class="text-danger">{{ 'paymentPage.cvvInvalid' | translate }}</span>
                </span>
              </div>
            </div>

            <div class="col-xs-6 col-sm-6 col-md-4" style="margin-top: 5px">
              <img width="100" [ngClass]="{'mr-3':!isRTL,'ml-5':isRTL}" src="assets/images/security_code_img.png" alt="Security Code Help" style="margin-left:-70px" />
            </div>

            <!--<div class="custom-control custom-checkbox">
              <input #agree class="custom-control-input" (change)="SaveCardOnFile($event)" type="checkbox" id="idCheck">
              <label class="custom-control-label" for="idCheck">{{'checkinpayment.save_card_For_Future'|translate}}. </label>
              <span class="ml-1 text-dark" (click)="showCardInfoPopup()"><i class="fas fa-info-circle"></i></span>
            </div>-->

            <div class="col-md-12 mt-1 text-center">
              <button class="btn btn-primary btncare mt-2" type="button" (click)="onSubmitPayment()">{{'button.make_payment'|translate}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!--<footer class="p-3">
    <div class="container p-0">
      <div class="row">
        <div class="col-4">
          <a *ngIf="!isNewPatient" class="btn btn-outline-primary" type="button" [routerLink]="['/payment-overview']">{{'button.back'|translate}}</a>
        </div>
        <div class="col-4 text-center">
           <p *ngIf="isNewPatient" class="mb-0">(3 of 3)</p>
        </div>
        <div class="col-4 text-right">
          <a class="btn btn-primary" type="button" (click)="onSubmitPayment()">{{'button.finish'|translate}}</a>
        </div>
      </div>
    </div>
  </footer>-->

  <footer class="p-3">
    <div class="container p-0">
      <div class="d-flex justify-content-between align-items-center">
        <a *ngIf="!isNewPatient" class="btn btn-outline-primary" type="button" [routerLink]="['/payment-overview']">{{'button.back'|translate}}</a>
        <a class="btn btn-primary" type="button" (click)="onSubmitPayment()">{{'button.finish'|translate}}</a>
      </div>
    </div>
  </footer>
</ng-container>
<ng-template #receipt>
  <div class="wrapper">
    <h5 class="main-title">{{patientpersonalinfo?.PracticeName}}</h5>
    <div class="container px-0">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card border">
            <div class="card-body">
              <div class="payment-print">
                <div class="payment-brand">
                  <div class=" row">
                    <div class="col-lg-6 text-left">
                      <h5 class="breeze-color font-weight-bold">Breeze Check-in</h5>
                    </div>
                    <div class="col-lg-6 text-right">
                      <!-- <p style="line-height: .1.5;" class="font-sz13">addresss,<br> line 2,dummy text</p> -->
                      <p style="line-height: .1.5;" class="fs-12 ltr-component">
                        <strong>{{practicedetails.practiceName | uppercase}}</strong><br> {{practiceAddressTrimmed[0] | titlecase}},<br> {{practiceAddressTrimmed[1] | titlecase}},
                        <br> {{practiceAddressTrimmed[2] | uppercase}}
                        <br>{{masked_cellPhone}} <br>{{practicedetails.practiceEmail}}
                      </p>
                    </div>
                  </div>
                </div>
                <h5 class="bg-info mb-3 p-3 text-center text-white">{{'paymentPage.paymentReceipt'|translate}}</h5>

                <ul class="payment-print-desc list-unstyled mb-0" [ngClass]="{'rtl': isRTL,'pl-0':!isRTL,'pr-0':isRTL}">
                  <li><strong>{{'paymentPage.dateTime'|translate}} :</strong>{{currentDate | date:'MMMM dd, yyyy'}}</li>
                  <!-- <li><strong>Transaction Date:</strong>January 11,2021</li> -->
                  <li><strong>{{'paymentPage.firstName'|translate}}:</strong>{{(patientpersonalinfo.first_Name | titlecase)|| 'N/A'}}</li>
                  <li><strong>{{'paymentPage.lastName'|translate}}:</strong>{{(patientpersonalinfo.last_Name | titlecase) || 'N/A'}}</li>
                  <!-- <li><strong>Response Message:</strong>{{PaymentResponse.response_message || 'N/A'}}</li> -->
                  <li class="text-wrap text-break w-100"><strong>{{'paymentPage.patientMRN'|translate}} :</strong>{{patientpersonalinfo.patient_Account || 'N/A'}}</li>
                  <li><strong>{{'paymentPage.creditCardType'|translate}} :</strong> {{(ObjPayment.cradittype | titlecase) || 'N/A'}}  </li>
                  <li><strong>{{'paymentPage.cardHolderName'|translate}} :</strong>{{(PaymentResponse.firstname | titlecase) + ' ' + (PaymentResponse.lastname | titlecase)}} </li>
                  <li class="text-wrap text-break w-100"><strong>{{'paymentPage.transactionID'|translate}}:</strong>{{PaymentResponse.transactionID || 'N/A'}}</li>
                  <!-- <li><strong>Response Code:</strong>{{PaymentResponse.response_code || 'N/A'}}</li> -->
                  <!-- <li><strong>Card Number:</strong>*******{{PaymentResponse.ccn || 'N/A'}}</li> -->
                  <li><strong>{{'paymentPage.authorizationAmount'|translate}} :&nbsp;</strong> ${{PaymentResponse.amount || 'N/A'}}</li>
                  <li><strong>{{'paymentPage.authorizationCode'|translate}} :</strong>{{PaymentResponse.authCode || 'N/A'}}</li>
                  <!-- <li><strong>Authorization Text :</strong></li> -->
                </ul>
                <div class="row pt-4 pb-3" [ngClass]="{'rtl': isRTL,'pl-0':!isRTL,'pr-0':isRTL}">
                  <div class="col-lg-12">
                    <p><i>{{'paymentPage.agreementText'|translate}} </i></p>
                  </div>
                </div>
                <div class="bg-light font-initial form-row px-3 py-4">
                  <!--<div class="col-12 col-md-8">
                    <div class="form-group mb-0">
                      <div class="form-floating custom-font-size">
                        <label class="custom-label">{{'paymentPage.emailReceiptAt'|translate}} </label>
                        <input type="text" class="form-control p-2" [(ngModel)]="objEmailReceipt.email"
                               placeholder="{{'paymentPage.enterEmail'|translate}}">
                        <span *ngIf="emError" class="text-danger">{{'paymentPage.enterValidEmail'|translate}}</span>
                        <label>{{'paymentPage.email'|translate}}</label>
                      </div>
                    </div>
                  </div>-->
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="mb-2 border-bottom">
                        <label class="fw-bold mb-2" style="font-size: 16px;">
                          {{ 'paymentPage.emailReceiptAt' | translate }}
                        </label>
                        <input type="text"
                               class="form-control border-0 p-2"
                               style="font-size: 14px !important;"
                               [(ngModel)]="objEmailReceipt.email"
                               placeholder="{{'paymentPage.enterEmail' | translate}}" />
                      </div>
                      <div class="mb-2">
                        <span *ngIf="emError" class="text-danger">
                          {{ 'paymentPage.enterValidEmail' | translate }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-auto mt-md-0">
                    <a class="btn btn-primary w-100 w-md-auto" type="button" (click)="sendReceiptEmail()"
                       href="javascript:void(0)">{{'paymentPage.send'|translate}}</a>
                  </div>
                </div>
                <div class="d-flex align-items-center mt-4 justify-content-center">
                  <p class="carecloud-blue mb-0 mt-3">{{'paymentPage.poweredBy'|translate}}</p><img class="cc-logo" src="assets\images\cclogo.png" alt="Powered by carecloud">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="p-3">
    <div class="container p-0">
      <div class="d-flex justify-content-center align-items-center">
        <a class="btn btn-primary" type="button" href="javascript:void(0)" (click)="finishClicked()">{{'button.finish'|translate}}</a>
      </div>
    </div>
  </footer>
</ng-template>

<!-- email sent dialog -->
<
<!--div data-backdrop="static" [ngStyle]="{'display' : emailSent ? 'block' : 'none'}" data-keyboard="false" class="modal modal-md collapse" id="emailsuccesss">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body  p-4 text-center">

        <h5 class="font-weight-bolder mb-3 text-primary"><strong>{{'paymentPage.emailSentSuccess'|translate}}</strong></h5>
        <button type="button" id="closeDeleteFamilyHistory" (click)="finishClicked()" class="btn btn-primary" data-dismiss="modal">{{'button.ok'|translate}}</button>
      </div>
    </div>
  </div>
</div>-->
<div class="modal modal-alert bd-example-modal-sm"  id="emailsuccess" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'paymentPage.email_Sent'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <p class="text-center">{{'paymentPage.emailSentSuccess'|translate}}</p>
        <div class="text-center">
          <!--<button type="button" data-toggle="modal" data-dismiss="modal" id="emailsuccess" class="btn btn-primary">{{'button.ok'|translate}}</button>-->
          <button type="button" id="closeDeleteFamilyHistory" (click)="finishClicked()"  class="btn btn-primary" data-dismiss="modal">{{'button.ok'|translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

